import { reportMenus } from "./reportMenus";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { clearAuth } from "../utils/auth";
import axios from "../utils/axiosConfig";
import { getStoredCompanyName, publishCompanyName } from "../utils/company";

const Topbar = ({ sidebarCollapsed = false, onToggleSidebar }) => {
  const [openMenu, setOpenMenu] = useState(null);
  const [companyName, setCompanyName] = useState(getStoredCompanyName);
  const navigate = useNavigate();
  const savedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const username = savedUser.fullName || savedUser.username || "User";

  useEffect(() => {
    let isMounted = true;

    axios.get("/company")
      .then((res) => {
        if (!isMounted) return;
        setCompanyName(publishCompanyName(res.data?.CompanyName));
      })
      .catch(() => {
        if (isMounted) setCompanyName(getStoredCompanyName());
      });

    const handleCompanyUpdate = (event) => {
      setCompanyName(event.detail?.companyName || getStoredCompanyName());
    };

    const handleStorage = (event) => {
      if (event.key === "activeCompanyName") setCompanyName(getStoredCompanyName());
    };

    window.addEventListener("company-name-updated", handleCompanyUpdate);
    window.addEventListener("storage", handleStorage);

    return () => {
      isMounted = false;
      window.removeEventListener("company-name-updated", handleCompanyUpdate);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  const handleLogout = () => {
    clearAuth();
    navigate("/login");
  };

  const handleMouseEnter = (menu) => setOpenMenu(menu);
  const handleMouseLeave = () => setOpenMenu(null);

  const menus = {
    Master: [
      { name: "Bank Master", path: "/master/bankmaster" },
      { name: "Buyer Bank Master", path: "/master/buyerbankmaster" },
      { name: "Buyer Master", path: "/master/buyermaster" },
      { name: "Contact Group Master", path: "/master/contactgroupmaster" },
      { name: "Document Master", path: "/master/documentmaster" },
      { name: "Forex Rate", path: "/master/forexrate" },
      { name: "Item ISRI Master", path: "/master/itemisrimaster" },
      { name: "Item Master", path: "/master/itemmaster" },
      { name: "HSN Master", path: "/master/hsnmaster" },
      { name: "Shipper Master", path: "/master/shippermaster" },
      { name: "User Type Master", path: "/master/usertypemaster" },
      { name: "User Master", path: "/master/usermaster" },
      { name: "User Rights", path: "/master/userrights" }
    ],
    Transaction: [
      { name: "Ongoing Deal", path: "/transaction/new-deal/list" },
      { name: "New Invoice", path: "/transaction/new-invoice/list" }
    ],
    Reports: reportMenus,
    "Crystal Reports": [
      { name: "Buyer Report", path: "/report/crystal-reports/buyer" },
      { name: "Shipper Report", path: "/report/crystal-reports/shipper" },
      { name: "SC Pending Report", path: "/report/crystal-reports/sc-pending" },
      { name: "SC Detail Report", path: "/report/crystal-reports/sc-detail" },
      { name: "FollowUp Detail Report", path: "/report/crystal-reports/followup" },
      { name: "Fixation Notice Report", path: "/report/crystal-reports/fixation-note" },
      { name: "Deal Fixation Notice Report", path: "/report/crystal-reports/deal-fixation-note" },
      { name: "Commission Report", path: "/report/crystal-reports/commission" },
      { name: "Shipment Pending Report", path: "/report/crystal-reports/shipment-pending" },
      { name: "Copy Document Pending Report", path: "/report/crystal-reports/copy-doc-pending" },
      { name: "Advance Pending Report", path: "/report/crystal-reports/advance-pending" },
      { name: "Deal Status Report", path: "/report/crystal-reports/deal-status" },
      { name: "Sales Report", path: "/report/crystal-reports/sales" },
      { name: "Shipment Due Report", path: "/report/crystal-reports/shipment-due" },
      { name: "Sales Contract Due Report", path: "/report/crystal-reports/sales-contract-due" },
      { name: "Document Release Pending Report", path: "/report/crystal-reports/doc-release-pending" },
      { name: "Invoice List Report", path: "/report/crystal-reports/invoice-list" },
      { name: "Pending Invoice Report", path: "/report/crystal-reports/pending-invoice" },
      { name: "Shipment Advice Report", path: "/report/crystal-reports/shipment-advice" },
      { name: "Bill Of Lading Report", path: "/report/crystal-reports/bill-of-lading" },
      { name: "Inward Remittance Report", path: "/report/crystal-reports/inward-remittance" },
      { name: "Payment Advice Report", path: "/report/crystal-reports/payment-advice" },
      { name: "Sales Turnover Report", path: "/report/crystal-reports/sales-turnover" },
      { name: "Weight Report", path: "/report/crystal-reports/weight" },
      { name: "Quality Report", path: "/report/crystal-reports/quality" },
      { name: "Document Dispatch Advice Report", path: "/report/crystal-reports/document-dispatch-advice" },
      { name: "Internal Invoice Report", path: "/report/crystal-reports/internal-invoice" },
      { name: "Final Buyer Report", path: "/report/crystal-reports/final-buyer" },
      { name: "Full Buyer Detail Report", path: "/report/crystal-reports/full-buyer-detail" },
      { name: "Full Shipper Detail Report", path: "/report/crystal-reports/full-shipper-detail" },
      { name: "Common Fixation Report", path: "/report/crystal-reports/common-fixation" },
      { name: "Supplier Statement Report", path: "/report/crystal-reports/supplier-statement" },
      { name: "External Supplier Statement Report", path: "/report/crystal-reports/external-supplier-statement" },
      { name: "Buyer Detail Report", path: "/report/crystal-reports/buyer-detail" },
      { name: "Shipper Detail Report", path: "/report/crystal-reports/shipper-detail" },
      { name: "Sales Contract Pending Report", path: "/report/crystal-reports/sales-contract-pending" },
      { name: "Deal Status Revised Report", path: "/report/crystal-reports/deal-status-revised" },
      { name: "Invoice Report", path: "/report/crystal-reports/invoice" },
      { name: "Buyer Summary Report", path: "/report/crystal-reports/buyer-summary" },
      { name: "Buyer Contact Detail Report", path: "/report/crystal-reports/buyer-contact-detail" },
      { name: "Buyer Dtl Report", path: "/report/crystal-reports/buyer-dtl" },
      { name: "Buyer Detail Test Report", path: "/report/crystal-reports/buyer-detail-test" },
      { name: "Buyer Detail Label Report", path: "/report/crystal-reports/buyer-detail-label" },
      { name: "Shipper Summary Report", path: "/report/crystal-reports/shipper-summary" },
      { name: "Shipper Contact Detail Report", path: "/report/crystal-reports/shipper-contact-detail" },
      { name: "Shipper Dtl Report", path: "/report/crystal-reports/shipper-dtl" },
      { name: "Shipper Detail Label Report", path: "/report/crystal-reports/shipper-detail-label" },
      { name: "Shipper Test Report", path: "/report/crystal-reports/shipper-test" }
    ],
    Tools: [
      { name: "Grid Settings", path: "/tools/grid-settings" },
      { name: "Company Setting", path: "/tools/company-setting" },
      { name: "Year Setting", path: "/tools/year-setting" },
      { name: "Database Detail", path: "/tools/database-detail" }
    ]
  };

  return (
    <header className="erp-topbar" onMouseLeave={handleMouseLeave}>
      <div className="erp-topbar-leading">
        <button
          type="button"
          className="erp-sidebar-toggle"
          onClick={onToggleSidebar}
          aria-label={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          aria-expanded={!sidebarCollapsed}
          title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <span aria-hidden="true">☰</span>
        </button>
        <h1 className="erp-topbar-brand" title={companyName} onClick={() => navigate("/dashboard")}>
          {companyName}
        </h1>
      </div>

      <nav className="erp-topbar-menu">
        <Link to="/dashboard" className="erp-topbar-menu-label" style={{ textDecoration: "none" }}
          onMouseEnter={() => setOpenMenu(null)} onClick={() => setOpenMenu(null)}>Dashboard</Link>
        {Object.keys(menus).map((mainMenu) => (
          <div
            key={mainMenu}
            onMouseEnter={() => handleMouseEnter(mainMenu)}
            className="erp-topbar-menu-item"
          >
            <span
              onClick={() => setOpenMenu(openMenu === mainMenu ? null : mainMenu)}
              className={`erp-topbar-menu-label ${openMenu === mainMenu ? "active" : ""}`}
            >
              {mainMenu}
            </span>

            {openMenu === mainMenu && (
              <div className="erp-topbar-dropdown">
                {menus[mainMenu].map((item) => item.children ? (
                  <details key={item.name} className="erp-report-topbar-group">
                    <summary>{item.name}</summary>
                    {item.children.map(child => <Link key={child.path} to={child.path} className="erp-topbar-dropdown-item" onClick={() => setOpenMenu(null)}>{child.name}</Link>)}
                  </details>
                ) : (
                  <Link
                    key={item.path}
                    to={item.path}
                    className="erp-topbar-dropdown-item"
                    onClick={() => setOpenMenu(null)}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))}

        <span className="erp-topbar-user">{username}</span>
        <button type="button" title="Logout" onClick={handleLogout} className="erp-topbar-logout">
          <FontAwesomeIcon icon={faSignOutAlt} />
        </button>
      </nav>
    </header>
  );
};

export default Topbar;
